import React, { useRef, useState } from "react";

import {
  IconButton,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useTranslations } from "hooks";
import { Add } from "@mui/icons-material";
import { getTranslation } from "common";

interface DailyRecurrenceGeneratorTypes {
  typeTwoDayValue: Record<string, boolean>;
  setTypeTwoDayValue: React.Dispatch<
    React.SetStateAction<Record<string, boolean>>
  >;
}

const DailyRecurrenceGenerator = (props: DailyRecurrenceGeneratorTypes) => {
  const { typeTwoDayValue, setTypeTwoDayValue } = props;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const translations = useTranslations();
  const inpRef = useRef<HTMLInputElement | null>(null);

  const [error, setError] = useState<boolean>(false);
  const handleSubmit = (
    target: EventTarget & (HTMLInputElement | HTMLTextAreaElement)
  ) => {
    if (target.value) {
      if (Number(target.value) <= 23 && Number(target.value) >= 0) {
        setTypeTwoDayValue((_) => ({
          ..._,
          [Number(target.value)]: true,
        }));
        target.value = "";
        target.focus();
      } else {
        setError(true);
      }
    }
  };

  return (
    <Stack spacing={2}>
      {Boolean(Object.keys(typeTwoDayValue).length) && (
        <Typography variant="caption">
          {getTranslation(translations, "generic.selecteddays")} {Object.keys(typeTwoDayValue).join(", ")}
        </Typography>
      )}
      <TextField
        size="small"
        type="number"
        error={error}
        helperText={error && getTranslation(translations, "generic.valueoutofrange")}
        defaultValue={0}
        InputLabelProps={{
          shrink: true,
        }}
        InputProps={{
          sx: { pr: 0 },
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={(e) => {
                  e.preventDefault();
                  setError(false);
                  inpRef.current && handleSubmit(inpRef.current);
                }}
                type="submit"
              >
                <Add />
              </IconButton>
            </InputAdornment>
          ),
        }}
        inputProps={{ max: 31, min: 1 }}
        label={getTranslation(translations, "system.pm.choose_days.label")}
        onBlur={(e) => handleSubmit(e.target)}
        onKeyDown={(e) => {
          setError(false);
          e.key === "Enter" &&
            handleSubmit(
              e.target as EventTarget &
              (HTMLInputElement | HTMLTextAreaElement)
            );
        }}
      />
    </Stack>
  );
};

export default DailyRecurrenceGenerator;
